import _ from 'lodash';

const rules = {
  password: [
    {
      check: (password) => password.length >= 8,
      message: 'Must be at least 8 characters',
    },
    {
      check: (password) => (/[a-z]/.test(password) && /[A-Z]/.test(password)),
      message: 'Must contain uppercase and lowercase letters',
    },
    {
      check: (password) => /[0-9]/.test(password),
      message: 'Must contain digits',
    },
  ],
  phone_number: {

  }
};

export default function(type, ...args) {
  let appliedRules = rules[type];
  if (!appliedRules) {
    console.warn(`Missing rules for type '${type}'. Defaults to valid.`);
    return true;
  }
  appliedRules = _.isArray(appliedRules) ? appliedRules : [appliedRules];

  return appliedRules.map((rule) => {
    if (!rule.check.apply(this, args)) {
      return rule.message;
    }
    return false;
  }).filter(message => message);
}


// WEBPACK FOOTER //
// ./src/lib/validator.js